<!-- static content data from lang: visitor_request -->
<template>
  <div>
    <div class="h-100" v-loading="loading">
       <template v-if="errored"> {{errored}}
         <!-- {{this.$router.push({path: '*'})}} -->
       </template>
    <template v-else>
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-12 col-12">
          <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.headerTitle}}</h6>
          <nav aria-label="breadcrumb" class="d-inline-block ml-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
          <div>
            <validation-observer v-slot="{handleSubmit}" ref="formValidator">
              <form role="form" @submit.prevent="handleSubmit(filter)">
              <div class="col-lg-12">
              <div class="row">
                <div class="col-md-6">
                  <base-input class="date-picker" labelClasses="form-control-label asterisk-mark"
                              :label="lang.label.fromDateRange" name="From date"
                              :rules="{required: true}">
                    <flat-picker
                      ref="fromDate"
                      :config="{disable: [fromDateDisable], disableMobile: 'true', dateFormat: 'd-m-Y', minDate:new Date().fp_incr(-365) ,maxDate: fromMaxDate }"
                      class="form-control datepicker"
                      v-model="model.fromDate"
                      :placeholder="lang.label.selectDate"
                    ></flat-picker>
                    <div class="flat-calenda-icon">
                                <span data-toggle>
                                  <i class="fas fa-calendar-alt text-primary"></i>
                                </span>
                    </div>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input class="date-picker" labelClasses="form-control-label asterisk-mark"
                              :label="lang.label.toDateRange" name="To date"
                              :rules="{required: true}">
                    <flat-picker
                      ref="toDate"
                      :config="{disable: [toDateDisable],disableMobile: 'true', dateFormat: 'd-m-Y', minDate:new Date().fp_incr(-365) ,maxDate:fromMaxDate}"
                      class="form-control datepicker"
                      v-model="model.toDate"
                      :placeholder="lang.label.selectDate"
                    ></flat-picker>
                    <div class="flat-calenda-icon">
                                <span data-toggle>
                                  <i class="fas fa-calendar-alt text-primary"></i>
                                </span>
                    </div>
                  </base-input>
                </div>
                <div class="col-md-12">
                  <div class="text-right mb-3">
                    <base-button type="primary " native-type="submit">{{lang.label.buttons.filter}}</base-button>
                  </div>
                </div>
                <div class="col-12 text-center text-lg-left">
                  <template v-for="(message) in alertMessages">
                    <Alert :type = alertType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
                  </template>
                  <template v-for="(message) in successMessages">
                    <Alert :type = successType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
                  </template>
                  <div class="row">
                    <div
                      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                    >
                      <el-select
                        class="select-primary pagination-select"
                        v-model="pagination.perPage"
                        autocomplete="off"
                        placeholder="Per page"
                      >
                        <el-option
                          class="select-primary"
                          v-for="item in pagination.perPageOptions"
                          :key="item"
                          :label="item"
                          :value="item"
                        ></el-option>
                      </el-select>

                      <div>
                        <base-input
                          v-model="searchQuery"
                          autocomplete="off"
                          prepend-icon="fas fa-search"
                          :placeholder="lang.label.search"
                        ></base-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                <el-table
                  :data="queriedData"
                  row-key="id"
                  header-row-class-name="thead-light"
                  @sort-change="sortChange"
                  @selection-change="selectionChange"
                  border
                >
                  <el-table-column min-width="150px" label="Site Name" prop="SiteName" sortable></el-table-column>
                  <!-- <el-table-column min-width="200px" label="Visitor Name" prop="CompanyName" sortable></el-table-column> -->
                  <el-table-column min-width="200px" label="Access Date"  sortable>
                    <!-- <template> -->
                    <div class="d-flex"  slot-scope="scope" ><span>{{formatDate(scope.row.AccessRequestDateFrom)}}</span> <span> &nbsp; - &nbsp;</span>
                    <span>  {{formatDate(scope.row.AccessRequestDateTo)}} </span>
                       </div>
                        <!-- </template> -->
                  </el-table-column>
                  <el-table-column min-width="150px" label="Department Name" prop="department_name" sortable></el-table-column>
                  <el-table-column min-width="150px" label="ID/Passport" prop="visitor_id" sortable></el-table-column>
                  <el-table-column min-width="150px" label="Visitor Name" prop="visitor_name" sortable></el-table-column>
                  <el-table-column min-width="150px" label="Visitor Surname" prop="visitor_surname" sortable></el-table-column>
                  <el-table-column min-width="150px" label="Mobile Number" prop="visitor_mobile" sortable></el-table-column>
                  <!-- <el-table-column label="Status" min-width="170px" prop="status" sortable> -->
                    <!-- <template v-slot="{row}">
                      <badge class="badge-dot mr-4" type>
                        <i :class="`bg-${row.statusType}`"></i>
                        <span class="status">{{row.status}}</span>
                      </badge>
                    </template>
                  </el-table-column> -->
                  <el-table-column width="150px" align="right" label="Status" prop="Status">
                    <div class="d-flex" slot-scope="scope">
                      <badge class="badge-dot mr-4" type>
                        <i :class="scope.row.Status.includes('Granted')? `bg-success`:(scope.row.Status.includes('Declined')?`bg-danger`: `bg-warning`)"></i>
                        <span class="status">{{scope.row.Status}}</span>
                      </badge>
                    </div>
                    <!--<div class="d-flex" slot-scope="scope">
                      <span>  {{scope.row.Status}} </span>
                    </div>-->
                  </el-table-column>
                  <el-table-column width="100px" align="right" label="Actions" prop="ID">
                    <div class="d-flex" slot-scope="scope">
                      <el-tooltip :content="lang.label.tooltips.view" placement="bottom">
                        <base-button class="btn-link" type="info" size="sm" icon @click="view(scope.row)">
                          <i class="text-white fas fa-eye"></i>
                        </base-button>
                      </el-tooltip>
                      <!-- <el-tooltip :content="lang.label.tooltips.approve" placement="bottom">
                        <base-button class="btn-link" type="success" size="sm" icon @click.native="showSwal($index, row)">
                          <i class="text-white fas fa-check"></i>
                        </base-button>
                      </el-tooltip> -->
                    </div>
                  </el-table-column>
                </el-table>
              </div>
              </div>
            </div>
              </form>
            </validation-observer>
          </div>
          <div
            class="col-12 mt-3 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                {{lang.label.showPagination.showing}} {{ from + 1 }} {{lang.label.showPagination.to}} {{ to }} {{lang.label.showPagination.of}} {{ total }} {{lang.label.showPagination.entries}}
                <span
                  v-if="selectedRows.length"
                >&nbsp; &nbsp; {{selectedRows.length}} {{lang.label.showPagination.rowsSelected}}</span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </card>
      </div>
    </div>
    </template>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {mapGetters} from "vuex";
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../../Tables/PaginatedTables/clientPaginationMixin";
import "sweetalert2/dist/sweetalert2.css";
import Alert from "@/components/BaseAlert.vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import FlashMessages from "@/views/GeneralViews/flash-message.vue";
import Login from "../Login";
var moment = require('moment');

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    flatPicker,
    FlashMessages,
    Alert,
  },
  data() {
    return {
      lang: this.$lang.visitor_request,
      fromMaxDate: new Date(),
      model: {
          fromDate: '',
          toDate: ''
      },
      alertType: 'danger',
      successType: 'success',
      alertMessages: [],
      successMessages: [],
      loading:true,
      errored:false,
      propsToSearch: ["ID","SiteName","AccessRequestDateFrom","AccessRequestDateTo","HostUser", "visitor_mobile", "visitor_name","visitor_surname","visitor_id"],
      selectedindex: 0,
      tableColumns: [
        {
          type: "selection"
        }
      ],
      tableData: [],
      selectedRows: [],
    };
  },
    computed:{
        ...mapGetters({
            disqualified: "disqualified",
        })
    },
    mounted(){
      let self = this;
      self.model.fromDate = moment(new Date()).format('DD-MM-YYYY');
      self.model.toDate = moment(new Date()).format('DD-MM-YYYY');
      if(this.disqualified && this.disqualified.includes('Based')) {
          self.alertMessages.push(this.disqualified);
      }else{
          self.successMessages.push(this.disqualified);
      }
    this.visitorsList();
  },
  methods: {
    filter(){
        this.visitorsList();
    },
    fromDateDisable(date) {
          // return (this.model.toDate ? moment(date).format('DD-MM-YYYY') > this.model.toDate : date > moment());
          return (this.model.toDate ? date > moment(this.model.toDate,"DD-MM-YYYY").toDate() : date > moment());
    },
    toDateDisable(date) {
          // return (this.model.fromDate ? moment(date).format('DD-MM-YYYY') < this.model.fromDate : date > moment());
        return (this.model.toDate ? date < moment(this.model.fromDate,"DD-MM-YYYY").toDate() : date > moment());
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    view(obj) {
      this.$router.push({ path: "view/"+ obj.ID});
    },
    onSubmit(){
    },
    formatDate(date){
        return  moment(date,'DD-MM-YYYY HH:mm').format('DD/MM/YYYY HH:mm');
    },
    visitorsList(){
     if(!(this.model.fromDate && this.model.fromDate)){
        return true;
     }
      let self = this;
      this.loading = true;
      let data = {
          "AccessFromDate": this.model.fromDate ? moment(this.model.fromDate, "DD-MM-YYYY").format('YYYY-MM-DD') : null,
          "AccessToDate": this.model.toDate ? moment(this.model.toDate, "DD-MM-YYYY").format('YYYY-MM-DD') : null
      };
      this.$store.dispatch('companyVisitorFormsList',data)
          .then(response => {
            setTimeout(function () {
              self.alertMessages = [];
              self.successMessages = [];
              self.$store.commit('setDisqualified','');
            },5000);
            this.tableData = response.data;
            this.loading = false;
          }).catch(error => {
            this.loading = false;
          }).finally(() => this.loading = false);
    },
  }
};
</script>

<style>
.no-border-card .card-footer {
  border-top: 0;
}
.modal-header {
  padding-bottom: 0;
}
</style>
